<template>
  <van-pull-refresh
    v-model="refreshing"
    success-text="刷新成功"
    @refresh="onRefresh"
  >
    <van-list
      class="list-container"
      v-model="listLoading"
      :finished="finished"
      :error.sync="error"
      :immediate-check="false"
      :offset="50"
      error-text="请求失败，点击重新加载"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <order
        :showComplaint="false"
        v-for="item in list"
        :key="item.bizId"
        :data="item"
        :customClass="['bg-white', 'order', 'margin-lr-8', 'radius']"
        @select="onSelect"
      ></order>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import Vue from 'vue'
import { PullRefresh, List } from 'vant'
import { mapMutations } from 'vuex'

import { getList as getOrderList } from 'api/order'
import Order from 'views/order/components/order-item'
Vue.use(PullRefresh).use(List)
export default {
  components: {
    Order
  },
  data () {
    return {
      refreshing: false,
      count: 0,
      listLoading: false,
      finished: false,
      params: {
        current: 1,
        size: 10
      },
      list: [],
      error: false
    }
  },
  created () {
    this.getOrderList(true)
  },
  methods: {
    ...mapMutations('service', ['changeOrder']),
    async getOrderList (loading = false) {
      getOrderList(this.params, loading)
        .then(res => {
          const { current, records, pages } = res
          if (current === 1) {
            this.list = records
          } else {
            this.list = [...this.list, ...records]
          }
          if (current >= pages) {
            this.finished = true
          } else {
            this.finished = false
            this.params.current = current + 1
          }
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.refreshing = false
          this.listLoading = false
        })
    },
    onRefresh () {
      this.params.current = 1
      this.getOrderList()
    },
    onLoad () {
      this.getOrderList()
    },
    onSelect (order) {
      this.changeOrder(order)
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.order {
  &:not(:last-child) {
    margin-top: 16px;
  }
}
</style>
